import Skeleton from "../../../components/Skeleton/Skeleton";
import useScreenSize from "../../../hooks/useScreenSize";

const PageSkeleton = () => {
  const { isMobile } = useScreenSize();

  return (
    <div className="flex flex-col gap-6 h-full min-h-[100vh]">
      {/* Controls row */}
      <div className="flex flex-wrap gap-4 items-center">
        <div className="flex gap-2">
          <Skeleton width="80px" height="36px" />
          <Skeleton width="80px" height="36px" />
          <Skeleton width="80px" height="36px" />
        </div>
        {!isMobile && (
          <>
            <Skeleton width="160px" height="40px" />
            <Skeleton width="160px" height="40px" />
            <Skeleton width="120px" height="40px" />
          </>
        )}
        {isMobile && (
          <>
            <Skeleton width="140px" height="40px" />
            <Skeleton width="140px" height="40px" />
          </>
        )}
      </div>

      {/* Graph card */}
      <div className="rounded-xl border border-[#EBEBEB] p-6">
        <Skeleton width="100%" height="280px" />
      </div>

      {/* Variation cards */}
      <div className={`flex gap-4 ${isMobile ? "flex-col" : ""}`}>
        {Array.from({ length: isMobile ? 2 : 4 }).map((_, i) => (
          <div key={i} className="rounded-xl border border-[#EBEBEB] p-4 flex-1">
            <Skeleton width="80px" height="14px" className="mb-2" />
            <Skeleton width="100%" height="40px" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PageSkeleton;
